import { Component, Inject } from '@angular/core';
import { EmailEditDialogModel } from './email-edit-dialog.model';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BaseComponent } from 'src/app/components/base.component';

@Component({
    selector: 'lex-email-edit',
    templateUrl: './email-edit.component.html',
    styleUrls: ['./email-edit.component.scss'],
    standalone: false
})
export class EmailEditComponent extends BaseComponent {
  public title: string;
  public emails: string[] = [];
  public emailInput: string = '';
  public editItem: string;

  private titleMap: Map<string, string> = new Map<string, string>([
    ['from', 'From Field'],
    ['to', 'To Field'],
    ['cc', 'CC Field'],
    ['bcc', 'BCC Field'],
  ]);

  constructor(@Inject(MAT_DIALOG_DATA) private data: EmailEditDialogModel,
    private dialogRef: MatDialogRef<EmailEditComponent>) {
    super();
    if (data.emails)
      this.emails = this.emails.concat(data.emails);

    if (data.type && this.titleMap.has(data.type)) {
      this.title = this.titleMap.get(data.type);
    }
  }

  public removeEmail(email: string): void {
    this.emails = this.emails.filter(e => e !== email);
  }

  public ok(): void {
    this.dialogRef.close(this.emails);
  }

  public onKeydown(event: KeyboardEvent) {
    if (event.key === 'Enter' || event.key === ';') {
      this.addEmail();
      event.preventDefault();
    }
  }

  public updateEmail(newValue: string, oldValue: string): void {
    const index = this.emails.indexOf(oldValue);
    if (index !== -1) {
      this.emails[index] = newValue;
    }
  }

  private addEmail() {
    const trimmedList = this.emailInput.trim();
    const inputs = trimmedList.split(';');
    inputs.map(i => {
      const trimmedEmail = i.trim();
      if (trimmedEmail && !this.emails.includes(trimmedEmail)) {
        this.emails.push(trimmedEmail);
        this.emailInput = '';
      }
    });
  }
}
